module.exports = __webpack_public_path__ + "img/mx.8ee3aa6a.svg";